import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const NUMBER = "917411934151";
const MESSAGE = "Hello Indoforce team, I'm interested in your products.";
const HREF = `https://wa.me/${NUMBER}?text=${encodeURIComponent(MESSAGE)}`;

export default function WhatsAppFab() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 900);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          data-testid="whatsapp-fab"
          href={HREF}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat with Indoforce on WhatsApp"
          initial={{ opacity: 0, y: 40, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 40, scale: 0.8 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="group fixed z-[60] bottom-6 right-6 md:bottom-8 md:right-8 flex items-center gap-3"
        >
          <span
            data-testid="whatsapp-fab-tooltip"
            className="hidden md:inline-flex items-center px-4 py-2 rounded-full bg-black/80 backdrop-blur border border-white/10 text-white text-[11px] uppercase tracking-[0.2em] opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
          >
            Chat on WhatsApp
          </span>
          <span className="relative grid place-items-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] shadow-[0_10px_30px_-8px_rgba(37,211,102,0.7)] hover:scale-105 active:scale-95 transition-transform">
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
            <svg
              viewBox="0 0 32 32"
              fill="white"
              className="relative w-7 h-7 md:w-8 md:h-8"
              aria-hidden="true"
            >
              <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.4 0 2.635-.68 2.635-1.9 0-.116-.03-.244-.048-.36-.09-.66-1.15-1.15-1.663-1.28-.144-.03-.315-.058-.472-.058m-3.32 8.24c-6.207 0-11.28-5.048-11.28-11.253 0-6.208 5.076-11.253 11.28-11.253 6.206 0 11.278 5.045 11.278 11.253 0 6.207-5.072 11.253-11.278 11.253m0-24.545c-7.377 0-13.348 5.945-13.348 13.29 0 2.317.616 4.588 1.79 6.588L2 32l6.83-1.99a13.35 13.35 0 0 0 6.96 1.94c7.376 0 13.34-5.94 13.34-13.284C29.13 6.936 23.165.9 15.79.9" />
            </svg>
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
}
